/* eslint-disable no-shadow */
import { Button, Card, Input, Switch, Table } from '@alifd/next';
import { DownloadOutlined } from '@ant-design/icons';
import axios from 'axios';
import React, { useState } from 'react';
import { SketchPicker } from 'react-color';
import ReactDragListView from 'react-drag-listview';

import styles from './templateContent.module.scss';
const label = {
  weather: '天氣',
  date: '日期',
  time: '時間',
  dateTime: '日期時間',
  text: '文字內容',
  announcement: '公告',
  image: '圖片',
  youtube: 'youtube影片',
  mp4: 'MP4影片',
};
const BroadcastTemplateContent = (props) => {
  const {
    count,
    addTemplateContent,
    ChangeTypeValue,
    setTemplateDialog,
    setTemplateDialogTitle,
    setTemplateDialogCount,
    onDragCategoryEnd,
    onsetUpdateValue,
    onChangeInitialValue,
    onDeleteTemplateValue,
    setTemplateUpdateIndex,
    // setTemplateImageDialog,
    setTypeValueData,
    setTypeColumns,
  } = props;
  const [showColor, setShowColor] = useState(false);

  return (
    <>
      <Card free className={styles.card}>
        <Card.Content>
          <h1>
            區塊{count === 0 && '一'}
            {count === 1 && '二'}
            {count === 2 && '三'}
          </h1>
          <div className={styles.ContentSetting}>
            <Button
              className={styles.buttonAdd}
              onClick={() => {
                setTemplateDialog(true);
                setTemplateDialogCount(count);
                setTemplateDialogTitle('insert');
                onChangeInitialValue();
                setTypeValueData([]);
              }}
            >
              新增內容
            </Button>
            {/* <Button
              className={styles.buttonAdd}
              onClick={() => {
                setTemplateImageDialog(true);
                // setTemplateDialog(true);
                setTemplateDialogCount(count);
                setTemplateDialogTitle('insert');
                onChangeInitialValue();
              }}
            >
              <DownloadOutlined />
              從媒體庫匯入
            </Button> */}
            <div className={styles.Setting}>
              循環輪播：
              <Switch
                defaultChecked={addTemplateContent[count].carousel}
                onChange={(value) => {
                  ChangeTypeValue(count, 'carousel', value);
                }}
              />
            </div>
            <div className={styles.Setting}>
              背景顏色：
              <div>
                <div style={{ display: 'inline-flex' }}>
                  <div
                    className={styles.color}
                    style={{
                      backgroundColor: addTemplateContent[count].color,
                    }}
                    onClick={() => setShowColor(true)}
                  />
                  <Input
                    value={addTemplateContent[count].color}
                    onClick={() => setShowColor(true)}
                    onChange={(value) => {
                      ChangeTypeValue(count, 'color', value);
                    }}
                  />
                </div>
                {showColor && (
                  <>
                    <div
                      className={styles.cover}
                      onClick={() => setShowColor(false)}
                    />
                    <SketchPicker
                      className={styles.colorPicker}
                      color={addTemplateContent[count].color}
                      onChangeComplete={(color) => {
                        ChangeTypeValue(count, 'color', color.hex);
                      }}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
          <p>
            <font style={{ color: 'red' }}>*</font>可拖曳表格欄位變換順序
          </p>
          <ReactDragListView
            onDragEnd={(fromIndex, toIndex) =>
              onDragCategoryEnd(fromIndex, toIndex, count)
            }
          >
            <Table dataSource={addTemplateContent[count].children}>
              <Table.Column
                title="類別"
                dataIndex="typeContent"
                width={150}
                align="center"
                cell={(value) => {
                  if (Object.hasOwn(label, value)) {
                    return label[value];
                  } else {
                    return value;
                  }
                }}
              />
              <Table.Column
                title="內容"
                dataIndex="typeFormat"
                width={200}
                align="center"
                cell={(value, _index, record) => {
                  if (record.typeContent === 'image') {
                    return (
                      <>
                        <img
                          src={value}
                          width="100%"
                          alt="圖片"
                          style={{ width: '150px' }}
                        />
                      </>
                    );
                  } else if (
                    record.typeContent === '空氣品質' ||
                    record.typeContent === '溫度' ||
                    record.typeContent === '濕度' ||
                    record.typeContent === '照度' ||
                    record.typeContent === '自定義'
                  ) {
                    return (
                      <>
                        {value.length > 0 &&
                          value.map((item) => (
                            <div>
                              裝置名稱：{item.originName}；顯示名稱：
                              {item.newName}
                            </div>
                          ))}
                      </>
                    );
                  } else if (
                    record.typeContent === 'youtube' ||
                    record.typeContent === 'mp4'
                  ) {
                    return <>{record.youtubeTitle}</>;
                  } else {
                    return (
                      <>
                        {value.split('\n').map((i) => (
                          <>
                            {i}
                            <br />
                          </>
                        ))}
                      </>
                    );
                  }
                }}
              />
              <Table.Column
                title="樣式"
                dataIndex="textColor"
                width={200}
                align="center"
                cell={(value, _index, record) => {
                  if (record.typeContent === 'image') {
                    return (
                      <>
                        <div>
                          樣式：
                          {(record.textSize === 'fullVersion' && '滿版') ||
                            (record.textSize === 'originalSize' && '原尺寸') ||
                            (record.textSize === 'repeat' && '重複填滿')}
                        </div>
                        <div style={{ textAlign: 'center' }}>
                          位置：水平
                          {(record.textLevel === 'center' && '置中') ||
                            (record.textLevel === 'left' && '靠左') ||
                            (record.textLevel === 'right' && '靠右')}
                        </div>
                      </>
                    );
                  } else {
                    return (
                      <>
                        <div>
                          大小：{record.textSize}px；
                          {record.textTags.map((x) => x)}
                        </div>
                        <div
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                          }}
                        >
                          顏色：
                          <div
                            className={styles.color}
                            style={{
                              backgroundColor: value,
                            }}
                          />
                          {value}
                        </div>
                        <div style={{ textAlign: 'center' }}>
                          位置：水平
                          {(record.textLevel === 'center' && '置中') ||
                            (record.textLevel === 'left' && '靠左') ||
                            (record.textLevel === 'right' && '靠右')}
                          ；垂直
                          {(record.textVertical === 'center' && '置中') ||
                            (record.textVertical === 'start' && '靠上') ||
                            (record.textVertical === 'end' && '靠下')}
                        </div>
                      </>
                    );
                  }
                }}
              />
              <Table.Column
                title="時間"
                dataIndex="seconds"
                width={150}
                align="center"
                cell={(value, _index, record) => {
                  if (record.typeContent === 'youtube') {
                    return (
                      <div style={{ textAlign: 'center' }}>
                        {record.startTime}秒~{record.endTime}秒 (共{value}秒)
                      </div>
                    );
                  } else {
                    return (
                      <div style={{ textAlign: 'center' }}>
                        {value}
                        {record.unit === 's' ? '秒' : '分'}
                      </div>
                    );
                  }
                }}
              />
              <Table.Column
                title="操作"
                width={100}
                align="center"
                cell={(_value, index, record) => {
                  return (
                    <div className={styles.btn}>
                      <Button
                        type="normal"
                        onClick={() => {
                          setTemplateDialog(true);
                          onsetUpdateValue(record);
                          setTemplateDialogTitle('update');
                          setTemplateDialogCount(count);
                          setTypeValueData(record.typeFormat);
                          setTemplateUpdateIndex(index);
                          let searchValue = '';
                          if (record.typeContent === '自定義') {
                            searchValue = '';
                          } else if (
                            record.typeContent === '空氣品質' ||
                            record.typeContent === '溫度' ||
                            record.typeContent === '濕度' ||
                            record.typeContent === '照度'
                          ) {
                            searchValue = record.typeContent;
                          }
                          axios
                            .get(`/ezcon/api/mqttTopic?topic=${searchValue}`, {
                              headers: {
                                authorization:
                                  localStorage.getItem('feathers-jwt'),
                              },
                            })
                            .then((res) => {
                              setTypeColumns(res.data);
                            })
                            .catch((err) => {
                              console.log(err);
                            });
                        }}
                      >
                        編輯
                      </Button>
                      <Button
                        type="primary"
                        warning
                        onClick={() => {
                          onDeleteTemplateValue(count, index);
                        }}
                      >
                        刪除
                      </Button>
                    </div>
                  );
                }}
              />
            </Table>
          </ReactDragListView>
        </Card.Content>
      </Card>
    </>
  );
};

export default BroadcastTemplateContent;
